import { useState, useEffect, useRef } from 'react'
import chatbotApi from '../../../services/chatbotApi'
import * as S from './styles'
import SwiperCore, { FreeMode } from 'swiper';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import { faShoppingBasket } from '@fortawesome/free-solid-svg-icons'
import { useSearch } from '../../../context/SearchContext';
import { IMAGE_URL } from '../../../constants';
import { useCart } from '../../../context/CartContext';

const CatalogHeader = () => {
  const { handleSearch, setIsChatbotCatalog } = useSearch()
  const { getCart } = useCart()
  const [searchValue, setSearchValue] = useState('')
  const [categories, setCategories] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const customer = JSON.parse(sessionStorage.getItem('customerChatbot'))
  const companyName = customer?.companyName
  SwiperCore.use([FreeMode]);

  const getCategories = async () => {
    if (isLoading) return;

    setIsLoading(true);
    const response = await chatbotApi.get(`/api/v2/Chatbot/Categories?OnlyB2B=true`);
    const data = response.data.response.data;
    setCategories(data);
    setIsLoading(false);
  }

  const renderCategoriesSwiper = (categories) => {
    return (
      <S.CatalogCategoriesSwiper
        slidesPerView="auto"
        spaceBetween={12}
        freeMode={true}
      >
        {
          categories.map((category) => (
            <S.CatalogSlide key={category.id}>
              <S.CategoryLink to={`/chatbot-catalog/category/${category.id}`}>
                <S.Category>
                  {category.imageUrl 
                    ? <S.CategoryImage src={`${IMAGE_URL}${category.imageUrl}`} alt="Imagem de capa para a categoria." />
                    : <S.CategoryIcon icon={faShoppingBasket} />
                  }
                </S.Category>
                <S.CategoryLabel>{category.description}</S.CategoryLabel>
              </S.CategoryLink>
            </S.CatalogSlide>
          ))
        }
      </S.CatalogCategoriesSwiper>
    )
  }

  useEffect(() => {
    getCategories();
    getCart();
  }, [])

  return (
    <>
      <S.CatalogHeader>
        <S.CompanyNameWrapper>
          <S.CompanyNameLink to='/chatbot-catalog'>
            <S.CompanyName>{companyName || ''}</S.CompanyName>
          </S.CompanyNameLink>
        </S.CompanyNameWrapper>
        <S.CatalogSearchBarWrapper>
          <S.CatalogSearchBar onChange={e => { handleSearch(e.target.value); setSearchValue(e.target.value); setIsChatbotCatalog(true) }} placeholder={'O que você está procurando?'} />
          <S.CatalogSearchBarIcon type="search" onClick={() => (handleSearch(searchValue), setIsChatbotCatalog(true))} />
        </S.CatalogSearchBarWrapper>
      </S.CatalogHeader>
      <S.CategoriesMenuWrapper>
        {renderCategoriesSwiper(categories)}
      </S.CategoriesMenuWrapper>
    </>
  )
}

export default CatalogHeader
